// material
import { alpha, styled } from '@mui/material/styles';
import { Card, Skeleton, Typography } from '@mui/material';
// utils
import { fShortenNumber } from '../../../Utils/formatNumber';
//
import Iconify from '../../../Components/Dashboard/Iconify';
import { useSelector } from 'react-redux';

// ----------------------------------------------------------------------
const getTrainer = state => state.trainersReducer;
const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(3, 0),
  color: theme.palette.warning.darker,
  backgroundColor: '#C3F6D5',
  borderRadius:'16px',
  // backgroundImage: 'linear-gradient(135deg, rgba(0, 123, 85, 0) 0%, rgba(0, 123, 85, 0.24) 100%)',
   // color:'#016C34',
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(5),
  height: theme.spacing(5),
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
  color:'#FFF',
  backgroundColor:'#3CD856',
   // backgroundImage: 'linear-gradient(135deg, rgba(0, 123, 85, 0) 0%, rgba(0, 123, 85, 0.24) 100%)',
}));

// ----------------------------------------------------------------------



export default function CardTotalTrainers() {
  const {totalTrainersDetails, isLoaded} = useSelector(getTrainer) 
  const TOTAL = totalTrainersDetails.totalTrainers
  return (
    <>
    {Object.keys(totalTrainersDetails).length === 0 && (isLoaded === true)?<Skeleton variant="rounded"width="168px" height="156px"/>:(
      <RootStyle>
      <IconWrapperStyle>
        <Iconify icon="fluent:person-star-24-filled" width={22} height={22} />
      </IconWrapperStyle>
      <Typography variant="h5"  fontWeight={700} fontSize={'25px'}>{fShortenNumber(TOTAL)}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72, fontSize:'12px'}}>
        Registered Trainers
      </Typography>
    </RootStyle>
    )}
    </>
    
  );
}
